import { useAtomValue, useExodus } from '@exodus/headless-ui';
import { useCallback } from 'react';
import { originAtom } from '../../atoms/index.js';
const useTrackAssetSwap = () => {
    const exodus = useExodus();
    const origin = useAtomValue(originAtom);
    return useCallback((params) => {
        const { success } = params;
        void exodus.analytics.track({
            event: 'ExchangeAssetSwap',
            properties: {
                origin,
                success,
            },
        });
    }, [exodus.analytics, origin]);
};
export default useTrackAssetSwap;
